import { render, staticRenderFns } from "./UpdateOwnerDialog.vue?vue&type=template&id=44db41e2&scoped=true&"
import script from "./UpdateOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateOwnerDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOwnerDialog.vue?vue&type=style&index=0&id=44db41e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db41e2",
  null
  
)

export default component.exports